import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStrikeAngle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 73.551,
	height: 34.802,
	viewBox: "0 0 73.551 34.802",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_128",
		"data-name": "Group 128",
		transform: "translate(0.5 0.5)",
		children: [/* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_33",
			"data-name": "Rectangle 33",
			width: 72.551,
			height: 33.802,
			transform: "translate(0)",
			fill: "none",
			stroke: "#040505",
			strokeWidth: 1,
			opacity: 0
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Group_127",
			"data-name": "Group 127",
			transform: "translate(17.622 4.874)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_271",
					"data-name": "Path 271",
					d: "M272.685,595.768c-.368.138-.787.3-1.235.478a22.96,22.96,0,0,1-5.11,1.613c-1.631.034-6.107-.485-7.957-.7a1.248,1.248,0,0,0-.726.138c-.134-.209-.269-.434-.4-.691-.846-1.643-2.909-5.757-2.929-5.8a1.056,1.056,0,0,0-1.888.946c.021.041,2.089,4.167,2.939,5.819a9.468,9.468,0,0,0,1.853,2.538c.01.033.018.063.03.1a3.355,3.355,0,0,1-1.679,1.155,4.262,4.262,0,0,1-1.767-.058c-.045-.01-.091-.008-.137-.015-.113-.367-.27-.828-.476-1.429a30.52,30.52,0,0,0-3.422-5.791,1.056,1.056,0,1,0-1.7,1.251,28.079,28.079,0,0,1,3.125,5.222c.268.784.412,1.24.49,1.5a2.129,2.129,0,0,0-.484,1.267,10.45,10.45,0,0,0,.131,1.979,19.117,19.117,0,0,0,.879,3.543,6.3,6.3,0,0,0,.079,2.366,1.058,1.058,0,0,0,.57.808,3.123,3.123,0,0,0,.392.158h-2.383a1.056,1.056,0,0,0,0,2.111h3.167a1.052,1.052,0,0,0,.7-1.844c.111.006.223.012.343.012a8.2,8.2,0,0,0,3.086-.644c2.746-1.112,11.2-5.582,11.6-5.795.178-.1,4.362-2.584,5.662-5.558.724-1.656.628-3.2-.256-4.134A2.276,2.276,0,0,0,272.685,595.768Zm.815,3.834c-.85,1.945-3.751,3.968-4.755,4.56-.086.046-8.721,4.609-11.367,5.681a5.461,5.461,0,0,1-3.058.421c-.035-.36-.057-.679-.057-.844l.063-.144a1.06,1.06,0,0,0,0-.843,15.808,15.808,0,0,1-.9-3.466,7.383,7.383,0,0,1-.094-1.6.028.028,0,0,1,.022-.008,6.255,6.255,0,0,0,2.665.063,5.769,5.769,0,0,0,3.316-2.483,1.056,1.056,0,0,0,.092-.928c-.076-.2-.149-.426-.208-.636,2.389.271,5.684.616,7.145.591,1.3-.016,3.334-.771,5.855-1.759.437-.171.846-.332,1.206-.466.146-.056.193-.008.221.021C273.827,597.957,273.937,598.6,273.5,599.6Z",
					transform: "translate(-247.874 -590.223)",
					fill: "#101820"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_272",
					"data-name": "Path 272",
					d: "M305.7,631.795h-3.167a1.056,1.056,0,0,0,0,2.111H305.7a1.056,1.056,0,0,0,0-2.111Z",
					transform: "translate(-273.186 -609.852)",
					fill: "#101820"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_273",
					"data-name": "Path 273",
					d: "M280.987,631.795h-7.726a1.056,1.056,0,1,0,0,2.111h7.726a1.056,1.056,0,0,0,0-2.111Z",
					transform: "translate(-259.363 -609.852)",
					fill: "#101820"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_274",
					"data-name": "Path 274",
					d: "M312.068,614.932a1.055,1.055,0,0,0-1.484-.16l-1.21.975a10.581,10.581,0,0,0-1.618-7.493l1.215.13a1.008,1.008,0,0,0,.115.006,1.056,1.056,0,0,0,.111-2.1l-3.953-.425a1.057,1.057,0,0,0-1.163.937l-.424,3.952a1.055,1.055,0,1,0,2.1.226l.178-1.654a8.489,8.489,0,0,1,1.368,6.03l-.823-1.021a1.056,1.056,0,1,0-1.644,1.325l2.495,3.1a1.056,1.056,0,0,0,1.484.16l3.1-2.495A1.056,1.056,0,0,0,312.068,614.932Z",
					transform: "translate(-274.21 -597.603)",
					fill: "#101820"
				})
			]
		})]
	})]
});
const ForwardRef = forwardRef(SvgStrikeAngle);
export { ForwardRef as ReactComponent };
